import { render, staticRenderFns } from "./FormComplaint.vue?vue&type=template&id=2053a544&"
import script from "./FormComplaint.vue?vue&type=script&lang=js&"
export * from "./FormComplaint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports